export default {
	copyrightClaims: '/copyright-claims',
	case: (claimId: number, caseId: number) =>
		`/copyright-claims/${claimId}/cases/${caseId}`,
	denyClaim: (id: number) => `/copyright-claims/${id}/deny`,
	copyrightClaim: (id: number) => `/copyright-claims/${id}`,
	acknowledgeCopyrightClaim: (id: number) =>
		`/copyright-claims/${id}/acknowledge`,
	solveCase: (claimId: number, caseId: number) =>
		`/copyright-claims/${claimId}/cases/${caseId}/solve`,
	banContent: (claimId: number, contentId: number) =>
		`/copyright-claims/${claimId}/content/${contentId}/ban`,
};
